module.exports = __webpack_public_path__ + "static/media/support1.abfc8ebc.svg";